import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class APIService {

    constructor(private httpClient: HttpClient) { }

    public get(uri: string): Observable<any> {
        return this.httpClient.get(environment.baseUrl + uri);
    }

    public post(uri: string, payload: any): Observable<any> {
        return this.httpClient.post(environment.baseUrl + uri, payload);
    }

    public postWithParams(uri: string, payload: any, queryParams?: { [param: string]: any }): Observable<any> {
        let params = new HttpParams();

        // Add query parameters if provided
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key] !== null && queryParams[key] !== undefined) {
                    params = params.append(key, queryParams[key]);
                }
            });
        }

        return this.httpClient.post(environment.baseUrl + uri, payload, { params });
    }

    public put(uri: string, payload: any): Observable<any> {
        return this.httpClient.put(environment.baseUrl + uri, payload);
    }

    public delete(uri: string, data): Observable<any> {
        return this.httpClient.delete(environment.baseUrl + uri + "/" + data);
    }

    public deleteInParam(uri: string): Observable<any> {
        return this.httpClient.delete(environment.baseUrl + uri);
    }

    public getWithParams(uri: string, queryParams?: { [param: string]: any }): Observable<any> {
        let params = new HttpParams();

        // Add query parameters if provided
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                params = params.append(key, queryParams[key]);
            });
        }

        return this.httpClient.get(environment.baseUrl + uri, { params });
    }
}
